import React from 'react';
import { Modal, Form, Input, Radio, Tag } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';

/**
 * 搜索按钮组件
 * 点击后显示搜索弹窗，确认后自动处理URL跳转
 */
const SearchButton = ({ 
  children = <SearchOutlined style={{ fontSize: 22, color: 'rgb(22, 119, 255)' }} />,
  searchOptions = { address: '地址', phoneNo: '电话' },
  onSearch,
  ...restProps
}) => {
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = React.useState(false);

  const getDefaultSearchType = () => {
    // 获取第一个选项的键作为默认值
    const keys = Object.keys(searchOptions);
    return keys.length > 0 ? keys[0] : '';
  };

  const getRadioOptions = () => {
    return Object.keys(searchOptions).map(key => ({
      value: key,
      label: searchOptions[key]
    }));
  };

  React.useEffect(() => {
    // 根据url 参数触发onSearch
    if (window.location.search) {
      const url = new URL(window.location);
      // 根据searchOptions 过滤成object
      const searchParams = {};
      
      Object.entries(searchOptions)
        .filter(([key]) => searchOptions?.[key])
        .forEach(([key]) => {
          const value = url.searchParams.get(key);
          if(value) searchParams[key] = value;
          form.setFieldsValue({ [key]: value })
        });

      console.log('searchParams', searchParams);

      // if (searchType && keyword) {
      //   form.setFieldsValue({ [searchType]: keyword });
      onSearch?.(searchParams);
      // }
    }
  }, [])

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const { keyword, searchType } = values;
      
      if (keyword && searchType) {
        // 内部处理URL构建和跳转
        const url = new URL(window.location);
        url.searchParams.set(searchType, keyword.trim());
        url.searchParams.set('page', 1);
        // 写入history
        window.history.pushState({}, "", url);
        // window.location.href = url.toString();
        onSearch?.({[searchType]: keyword.trim()});
      }
      
      setModalVisible(false);
    } catch (error) {
      console.error('验证失败:', error);
    }
  };

  return (
    <>
      <span onClick={() => setModalVisible(true)} {...restProps}>
        {children}
      </span>
      
      <Modal
        title="搜索"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleOk}
      >
        <Form form={form} layout="vertical">
          <Form.Item 
            name="searchType" 
            initialValue={getDefaultSearchType()}
            style={{ marginBottom: '10px' }}
          >
            <Radio.Group 
              optionType="button" 
              size="middle"
              options={getRadioOptions()}
            />
          </Form.Item>
          <Form.Item
            name="keyword"
            rules={[{ required: true, message: '请输入搜索关键词!' }]}
          >
            <Input placeholder="请输入搜索关键词" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

/**
 * 搜索条件展示组件
 * 展示当前URL中的搜索条件，并提供关闭功能
 */
const SearchTags = ({ 
  options = { address: '地址', phoneNo: '电话' },
  onClose,
  ...restProps
}) => {
  // 从options中提取所有的键
  const searchKeys = Object.keys(options);
  
  const url = new URL(window.location);
  const searchParams = Array.from(url.searchParams).filter(([key]) => searchKeys.includes(key));
  // console.log('searchParams', Array.from(url.searchParams), searchKeys, searchParams);
  const handleClose = (key, value) => {
    // 内部处理URL更新和跳转
    url.searchParams.delete(key);
    url.searchParams.set('page', 1);
        // 写入history
    window.history.pushState({}, "", url);
    // window.location.href = url.toString();
    onClose?.({[key]: value});
  };

  return (
    <div {...restProps}>
      {searchParams.map(([key, value]) => {
        return (
          <Tag 
            key={key} 
            color="green" 
            style={{ margin: '0 5px 0 0' }} 
            closable 
            onClose={() => handleClose(key, value)}
            closeIcon={<CloseOutlined />}
          >
            {options[key]}: {'...' + value.slice(-4)}
          </Tag>
        );
      })}
    </div>
  );
};

SearchButton.Tags = SearchTags;

export default SearchButton;